import { WxSdk } from './WxSdk'

const wxSdk = new WxSdk()
// 第三方小程序支付页
export const CITY_PAY_URL_MAP = {
  '521': '/pages/pay/pay?',
  '046': '/pages/h5Pay/h5Pay?channel=xygj&',
}
export class MpUtil {
  static getUrl(to, params = {}) {
    const query = Object.keys(params || {}).map(key => `${key}=${params[key]}`).join('&')
		const url = `/pages/main/index?_f_=h5&_t_=${to}&${query}`
    return url
  }
  static getThirdPartyUrl(cityId, params = {}) {
    const query = Object.keys(params || {}).map(key => `${key}=${params[key]}`).join('&')
		const url = `${CITY_PAY_URL_MAP[cityId]}${query}`
    console.log('第三方小程序支付页url:', url)
    return url
  }

  static async navigateTo(url) {
    try {
      await wxSdk.loadWxJsSdk()
      wx.miniProgram.navigateTo({
        url,
      })
      return true
    } catch (e) {
      console.error('navigateTo error:', e)
      return false
    }
  }
}